import React from "react";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import BreadCrumb from '../../components/BreadCrumb';

const ELearning = () => {
    return (
        <div>
            <Navbar />
                <div class="container">
                    <BreadCrumb 
                        active_page="eLearning" 
                        prev_sub_page={{
                            'link':'/services',
                            'text':'Services'
                        }}
                        sub_page={{
                            'link':'/services/business-domains',
                            'text':'Business Domains'
                        }} 
                    />
                    <div class="inner-container">
                        <h2>eLearning</h2>
                        <h3>You Name It, We Provide It</h3>
                        <p>Solutions should not only solve problems but add value to the environment in which the solution is offered.</p>
                        <p>We just don’t create eLearning tools, but offer you an incredible learning experience. Our eLearning solutions involves a classroom blended virtual delivery mode of approach</p>
                        <h3>How Do We Do</h3>
                        <p>We blend together instructional design strategies and visual principles to create customized e Learning solutions.</p>
                        <h3>Technology At Its Best</h3>
                        <h3>LMS</h3>
                        <p>Ease your administration activities and improve learning outcomes through learning management system. Our range of learning methodologies will ensure no child is left behind in learning.</p>
                        <ul>
                            <li>Academic schedules</li>
                            <li>Learning resources</li>
                            <li>Remote learning</li>
                            <li>Assessment</li>
                            <li>Reports</li>
                        </ul>
                        <h3>Exam Assessment Tool</h3>
                        <p>You can create your online tests automatically and assess performance of your students</p>
                        <ul>
                            <li>Automated Tests</li>
                            <li>User Management</li>
                            <li>Craft Questions</li>
                        </ul>
                        <h3>Virtual Classrooms</h3>
                        <p>It’s never been easier to teach online. We help you digitize the classroom environment and enhance learning experiences</p>
                        <ul>
                            <li>Integrated scheduler</li>
                            <li>Reports</li>
                            <li>Recorded Sessions</li>
                            <li>Notifications</li>
                        </ul>
                        <h3>Education Management Software</h3>
                        <p>Convenient cloud based solution to manage school administration activities in a comprehensive way</p>
                        <ul>
                            <li>Paperless Technology</li>
                            <li>Actionable Insights</li>
                            <li>RFID Readers</li>
                            <li>Real Time GPS Access</li>
                            <li>Online Fee Payments</li>
                        </ul>
                    </div>
                </div>
            <Footer />
        </div>
    );
};

export default ELearning;